import {
  FaEnvelope,
  FaFax,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaRegPaperPlane,
  FaUserCheck,
} from 'react-icons/fa';
import { companyInfo, fullAddress } from '../constants/companyInfo';

export default function ContactPage() {
  return (
    <>
      <section className="relative overflow-hidden bg-white py-16">
        <div className="pointer-events-none absolute -left-16 top-10 h-56 w-56 rounded-full bg-teal-100 blur-3xl" />
        <div className="pointer-events-none absolute -right-16 bottom-10 h-64 w-64 rounded-full bg-cyan-100 blur-3xl" />
        <div className="mero-wrapper grid gap-10 lg:grid-cols-[1fr_1fr] lg:items-start">
          <div className="relative">
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-teal-700">
              Contact Us
            </p>
            <h1 className="mt-3 text-4xl font-bold tracking-tight text-slate-900">
              Start your eligibility and care conversation
            </h1>
            <p className="mt-5 text-slate-600">
              Our team can help you understand whether your loved one may
              qualify for home care services and what documents are needed to
              begin. Reach out by phone, email, or the form below.
            </p>

            <div className="mt-8 space-y-4 rounded-2xl border border-slate-200 bg-slate-50 p-6 text-slate-700">
              <p className="flex items-start gap-3">
                <FaMapMarkerAlt className="mt-1 text-teal-700" />
                <span>
                  <span className="font-semibold">Address:</span> {fullAddress}
                </span>
              </p>
              <p className="flex items-start gap-3">
                <FaPhoneAlt className="text-teal-700" />
                <span>
                  <span className="font-semibold">Phone:</span> {companyInfo.phone}
                </span>
              </p>
              <p className="flex items-start gap-3">
                <FaFax className="text-teal-700" />
                <span>
                  <span className="font-semibold">Fax:</span> {companyInfo.fax}
                </span>
              </p>
              <p className="flex items-start gap-3">
                <FaEnvelope className="text-teal-700" />
                <span>
                  <span className="font-semibold">Email:</span> {companyInfo.email}
                </span>
              </p>
            </div>
          </div>

          <form className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <h2 className="inline-flex items-center gap-2 text-xl font-semibold text-slate-900">
              <FaRegPaperPlane className="text-teal-700" /> Send us a message
            </h2>
            <div className="mt-6 grid gap-4">
              <input
                type="text"
                placeholder="Your Name"
                className="rounded-lg border border-slate-300 px-4 py-3 text-sm outline-none ring-teal-300 transition focus:ring"
              />
              <input
                type="email"
                placeholder="Your Email"
                className="rounded-lg border border-slate-300 px-4 py-3 text-sm outline-none ring-teal-300 transition focus:ring"
              />
              <input
                type="text"
                placeholder="Phone"
                className="rounded-lg border border-slate-300 px-4 py-3 text-sm outline-none ring-teal-300 transition focus:ring"
              />
              <textarea
                placeholder="Message"
                rows={4}
                className="rounded-lg border border-slate-300 px-4 py-3 text-sm outline-none ring-teal-300 transition focus:ring"
              />
            </div>

            <button
              type="button"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-teal-700 px-6 py-3 text-sm font-semibold text-white transition hover:bg-teal-800"
            >
              <FaUserCheck />
              Send Message
            </button>
          </form>
        </div>
      </section>

      <section className="pb-16">
        <div className="mero-wrapper overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
          <iframe
            title="Golden Hands Home Care location"
            src="https://www.google.com/maps?q=2405+Linglestown+Rd+Suite+4,+Harrisburg,+PA+17110&output=embed"
            className="h-[420px] w-full"
            loading="lazy"
          />
        </div>
      </section>
    </>
  );
}
